export const UPDATE_LIVE_CHAT_BRIGHT_PATTERN = 'UPDATE_LIVE_CHAT_BRIGHT_PATTERN';
export const UPDATE_LIVE_CHAT_CRM_D365 = 'UPDATE_LIVE_CHAT_CRM_D365';
export const UPDATE_END_LIVE_CHAT = 'UPDATE_END_LIVE_CHAT';
export const BRIGHT_PATTERN = 'livechat_tt_ggil';
export const SET_BRIGHT_PATTERN_CONTEXT = 'SET_BRIGHT_PATTERN_CONTEXT';
export const SET_CRM_CONTEXT = 'SET_CRM_CONTEXT';
export const START_GLL_LIVE_CHAT = 'START_GLL_LIVE_CHAT';
export const END_GLL_LIVE_CHAT = 'END_GLL_LIVE_CHAT';
export const UPDATE_GLL_CHAT_BOT_STATUS = 'UPDATE_GLL_CHAT_BOT_STATUS';
